/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateDestinationRequestDestination } from './UpdateDestinationRequestDestination';
import {
    UpdateDestinationRequestDestinationFromJSON,
    UpdateDestinationRequestDestinationFromJSONTyped,
    UpdateDestinationRequestDestinationToJSON,
} from './UpdateDestinationRequestDestination';

/**
 * 
 * @export
 * @interface UpdateDestinationRequest
 */
export interface UpdateDestinationRequest {
    /**
     * Array of field paths specifying which fields to update. Allowed values include:
     * - name
     * - metadata.url
     * - metadata.headers
     * - metadata.region
     * - metadata.streamName
     * - metadata.endpointUrl
     * - metadata.partitionKeyTemplate
     * - metadata.bucket
     * - metadata.keyTemplate
     * - metadata.storageClass
     * - metadata.username
     * - metadata.tableName
     * - metadata.database
     * - metadata.accountIdentifier
     * - metadata.userId
     * - metadata.dbName
     * - metadata.schemaName
     * - metadata.projectId
     * - metadata.datasetId
     * - metadata.tableId
     * - metadata.workgroupName
     * - metadata.clusterIdentifier
     * - metadata.dbUser
     * - metadata.account
     * - metadata.container
     * - metadata.queueUrl
     * - metadata.topicId
     * - metadata.serverUrl
     * - metadata.exchange
     * - metadata.tls
     * - metadata.name
     * - metadata.batchSize
     * - metadata.maxWaitSecs
     * - secrets.awsKeyId
     * - secrets.awsSecretKey
     * - secrets.awsSessionToken
     * - secrets.password
     * - secrets.privateKey
     * - secrets.credentials
     * - secrets.accessKeyId
     * - secrets.secretAccessKey
     * - secrets.accessKey
     * - secrets.username
     * - secrets.connectionString
     * @type {Array<string>}
     * @memberof UpdateDestinationRequest
     */
    updateMask: Array<string>;
    /**
     * 
     * @type {UpdateDestinationRequestDestination}
     * @memberof UpdateDestinationRequest
     */
    destination: UpdateDestinationRequestDestination;
}

/**
 * Check if a given object implements the UpdateDestinationRequest interface.
 */
export function instanceOfUpdateDestinationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateMask" in value;
    isInstance = isInstance && "destination" in value;

    return isInstance;
}

export function UpdateDestinationRequestFromJSON(json: any): UpdateDestinationRequest {
    return UpdateDestinationRequestFromJSONTyped(json, false);
}

export function UpdateDestinationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDestinationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateMask': json['updateMask'],
        'destination': UpdateDestinationRequestDestinationFromJSON(json['destination']),
    };
}

export function UpdateDestinationRequestToJSON(value?: UpdateDestinationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateMask': value.updateMask,
        'destination': UpdateDestinationRequestDestinationToJSON(value.destination),
    };
}

